import { useTranslate } from '@si/utils';
import { useLocation } from 'react-router';

import { useColors } from '../ThemeProvider';

export function ToMainContent() {
  const location = useLocation();
  const goToLocation = location.pathname + location.search + '#main';

  const { primary, white } = useColors();
  const { t, translate } = useTranslate();

  return (
    <a
      href={goToLocation}
      style={{
        position: 'absolute',
        top: '-100px',
        left: '50%',
        transform: 'translate(-50%)',
        backgroundColor: primary,
        color: white,
        padding: '10px',
      }}
      onFocus={(e) => (e.currentTarget.style.top = '0')}
      onBlur={(e) => (e.currentTarget.style.top = '-100px')}
    >
      {translate(t.toMainContent)}
    </a>
  );
}
